import React from 'react';
import TokenHandler from 'components/TokenHandler';
import RedirectorHOC from 'components/RedirectorHOC';

const withTokenHandler = WrappedComponent => props => (
  <TokenHandler>
    <RedirectorHOC>
      <WrappedComponent {...props} />
    </RedirectorHOC>
  </TokenHandler>
);

export default withTokenHandler;
